module.exports = __webpack_public_path__ + "img/FAV_0154.4dcc3679.jpg";